import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Trash = (props) => (
  <Icon viewBox="0 0 390 445" {...props}>
    <g>
      <g fill="currentColor">
        <path d="M181 184h28v193h-28zM124 184h28v193h-28zM238 184h29v193h-29z" />
        <path d="M267 65V9H124v56H9v29h29v343h314V94h29V65H267zM152 36h86v30h-86V36zm172 373H67V94h257v315z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Trash;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Trash.js